import React, { PureComponent } from 'react';
import dayjs from 'dayjs';
import {
  Form,
  Button,
  Input,
  Table,
  DatePicker,
  Card,
  Row,
  Col,
  Select,
  TreeSelect,
} from 'antd-v5';
import PageHeaderLayout from '../../../component/page-header-layout/index';

import './index.less';
import { fetchPayEntryDataDetailRequest } from '../../../state/request/payEntryData';
import { marketList } from '../../../state/request/stall';
import { getAllDistrictInfo } from '../../../state/request/mergeSet';

const FormItem = Form.Item;
const { RangePicker } = DatePicker;

class BankPaymentDetail extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      params: {},
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      pageList: [],
      loading: false,
      cityOptions: [],
      marketOptions: [],
    };
    this.formRef = null;
    this.columns = [
      {
        title: '商行业务ID',
        dataIndex: 'businessCode',
      },
      {
        title: '商行名称',
        dataIndex: 'stallName',
      },
      {
        title: '城市',
        dataIndex: 'cityName',
        render: (text, record) => {
          return `${record.provinceName || ''} ${record.cityName || ''}`;
        },
      },
      {
        title: '联系人姓名',
        dataIndex: 'contactName',
      },
      {
        title: '联系人手机号',
        dataIndex: 'contactPhone',
      },
      {
        title: '被追讨人姓名',
        dataIndex: 'debtorName',
      },
      {
        title: '被追讨人手机号',
        dataIndex: 'debtorPhone',
      },
      {
        title: '还款金额',
        dataIndex: 'repaymentAmount',
        render: (text) => (text ? `¥${Number(text).toLocaleString()}` : '¥0'),
      },
      {
        title: '还款时间',
        dataIndex: 'repaymentCreateTime',
        render: (text) => {
          return text ? dayjs(text).format('YYYY-MM-DD') : '';
        },
      },
      {
        title: '数据更新时间',
        dataIndex: 'createTime',
        render: (text) => {
          return text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : '';
        },
      },
    ];
  }

  //初始加载
  componentDidMount() {
    this.loadFilterOptions();
    this.doRequest();
  }

  loadFilterOptions = async () => {
    const [districtRes, marketRes] = await Promise.all([getAllDistrictInfo(), marketList({})]);
    const districtData = districtRes?.data;
    const marketData = marketRes?.data;
    const { mapping } = districtData || {};
    const { origins } = mapping || [];
    // 去掉区级节点，只保留到市级
    if (origins instanceof Array) {
      for (const iterator of origins) {
        for (const iteratorChildren of iterator.children) {
          delete iteratorChildren.children;
        }
      }
    }
    const marketOptions = Array.isArray(marketData)
      ? marketData.map((item) => ({
          label: item.name,
          value: item.id,
        }))
      : [];
    this.setState({ cityOptions: origins, marketOptions });
  };

  doRequest = async () => {
    const { pageNo, pageSize, params } = this.state;
    console.log('pageNo, pageSize, params: ', pageNo, pageSize, params);
    const { repaymentTime, businessCode, ...rest } = params;
    this.setState({ loading: true });
    const { code, data = {} } = await fetchPayEntryDataDetailRequest({
      pageNo,
      pageSize,
      repaymentStartTime: repaymentTime?.[0]?.valueOf(),
      repaymentEndTime: repaymentTime?.[1]?.valueOf(),
      businessCode,
      ...rest,
    });
    this.setState({ loading: false });
    if (code === 200) {
      this.setState({ pageList: data.pageList || [], totalSize: data.totalSize || 0 });
    }
  };

  //提交请求
  handleSubmit = (values) => {
    this.setState({ pageNo: 1, params: values }, this.doRequest);
  };

  // 分页切换
  pageSwitch = (obj) => {
    this.setState({ pageNo: obj.current }, this.doRequest);
  };
  //重置
  handleReset = () => {
    this.formRef.resetFields();
    this.setState({ pageNo: 1, params: {} }, this.doRequest);
  };

  getExtraContent() {
    const { cityOptions, marketOptions } = this.state;
    return (
      <div className='wrapper'>
        <Form
          ref={(r) => {
            this.formRef = r;
          }}
          onFinish={this.handleSubmit}
        >
          <Row gutter={24}>
            <Col span={6}>
              <FormItem name='districtList' label='城市'>
                <TreeSelect
                  allowClear
                  multiple
                  maxTagCount={2}
                  showSearch
                  treeData={cityOptions}
                  placeholder='请选择城市'
                  treeDefaultExpandAll={false}
                  filterTreeNode={(input, treeNode) => {
                    return treeNode?.title?.indexOf(input) >= 0;
                  }}
                />
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem name='marketIdList' label='市场'>
                <Select
                  placeholder='请选择市场'
                  allowClear
                  mode='multiple'
                  maxTagCount={2}
                  showSearch
                  options={marketOptions}
                  optionFilterProp='label'
                />
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem name='businessCode' label='商行业务ID'>
                <Input placeholder='商行业务ID' allowClear />
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem name='stallName' label='商行名称'>
                <Input placeholder='商行名称' allowClear />
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem name='phone' label='手机号'>
                <Input placeholder='搜索手机号' allowClear />
              </FormItem>
            </Col>
            <Col span={6}>
              <Form.Item name='repaymentTime' label='还款时间'>
                <RangePicker
                  format='YYYY-MM-DD'
                  placeholder={['开始时间', '结束时间']}
                  disabledDate={(current) => {
                    return current && current > dayjs().endOf('day');
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <FormItem>
                <Button type='primary' htmlType='submit'>
                  查询
                </Button>
                <Button style={{ marginLeft: '16px' }} onClick={this.handleReset}>
                  重置
                </Button>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
  render() {
    const { pageList = [], pageNo, pageSize, totalSize, loading } = this.state;
    const extraContent = this.getExtraContent();

    const pagination = {
      pageSize: pageSize,
      current: pageNo,
      total: totalSize,
      showSizeChanger: true,
      onShowSizeChange: (current, pageSize) => {
        this.setState({ pageSize, pageNo: 1 }, this.doRequest);
      },
    };
    return (
      <PageHeaderLayout>
        <Card bordered={false}>
          {extraContent}
          <Table
            dataSource={pageList}
            columns={this.columns}
            pagination={pagination}
            onChange={this.pageSwitch}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </Card>
      </PageHeaderLayout>
    );
  }
}
export default BankPaymentDetail;
